module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography-wideAngle-mobile.2977e700.jpg";